import 'react-app-polyfill/stable';
import React from 'react';
import { createRoot } from 'react-dom/client';
import {browserHistory} from 'react-router';
import {syncHistoryWithStore} from 'react-router-redux';
import Root from './Router';
// Storage - localstorage
import Storage from 'store';

// Initialize Storage
import expirePlugin from 'store/plugins/expire';

// Redux store
import store from './store';

// import 'bootstrap/dist/css/bootstrap.min.css';

Storage.addPlugin(expirePlugin);
window._Storage = Storage;
// Initialize react-router-redux.
const history = syncHistoryWithStore(browserHistory, store);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Root history={history}/>);
